import type { HierarchicalCategoryDTO } from '@/services/generated/ECAPIProductsDTOs';

export type CategoryCode = string;

export type Categories = Map<CategoryCode, Category>;

export type Category = {
  id: string;
  name: string;
  code: CategoryCode;
  description?: string;
  subCategories?: Category[];
};

export function findCategoryById(
  categories: HierarchicalCategoryDTO[],
  id: string
): HierarchicalCategoryDTO | undefined {
  return categories.find((cat) => cat.id === id);
}

export function findCategoryByCode(
  categories: HierarchicalCategoryDTO[],
  code: CategoryCode
): HierarchicalCategoryDTO | undefined {
  return categories.find((cat) => cat.code === code);
}
